var Stack = require('@antv/adjust/lib/stack');
module.exports = Stack;